import { IMultiOrderOrchestrator } from "@nju/data-access-portal-orchestrator";
import { Icon } from "@nju/icons";
import { BlockText, Text } from "@nju/ui";
import {
  formatAddress,
  formatPhoneNumber,
  IAddress,
  POSITIVE_DIGITS,
} from "@nju/utils";

interface IInfoProps {
  contactNumber: string | undefined;
  deliveryAddress: IAddress | undefined;
  deliveryMethodId: IMultiOrderOrchestrator["deliveryMethodId"];
  note: string | undefined;
}

export function Info({
  contactNumber,
  deliveryAddress,
  deliveryMethodId,
  note,
}: IInfoProps) {
  const icon = "mr-4 w-6 h-6 from-tablet:w-7 from-tablet:h-7";

  return (
    <div className="grid from-tablet:grid-cols-2 gap-4">
      {(deliveryMethodId === "BLISTER" || deliveryMethodId === "COURIER") && (
        <div className="items-center flex">
          <Icon
            className={icon}
            name={deliveryMethodId === "COURIER" ? "truck" : "person-carry"}
            tone="accent"
          />
          <div className="flex-1">
            <Text
              size={{
                "@onlyMobile": "s",
                "@fromTablet": "m",
              }}
            >
              sposób dostawy
            </Text>
            <BlockText
              className="block"
              size={{
                "@onlyMobile": "s",
                "@fromTablet": "l",
              }}
              weight="bold"
            >
              {deliveryMethodId === "COURIER" && "wysyłka kurierem"}
              {deliveryMethodId === "BLISTER" && "odbiór osobisty"}
            </BlockText>
          </div>
        </div>
      )}
      {contactNumber &&
        deliveryMethodId !== "ESIM" &&
        deliveryMethodId !== "PREOWNED" && (
          <div className="items-center flex">
            <Icon className={icon} name="phone" tone="accent" />
            <div className="flex-1">
              <Text
                size={{
                  "@onlyMobile": "s",
                  "@fromTablet": "m",
                }}
              >
                numer do kontaktu (dla kuriera)
              </Text>
              <BlockText
                className="block"
                size={{
                  "@onlyMobile": "s",
                  "@fromTablet": "l",
                }}
                weight="bold"
              >
                {formatPhoneNumber(contactNumber, POSITIVE_DIGITS, " ", "+48")}
              </BlockText>
            </div>
          </div>
        )}
      {deliveryAddress && deliveryMethodId !== "ESIM" && (
        <div className="items-center flex">
          <Icon className={icon} name="map-marked-alt" tone="accent" />
          <div className="flex-1">
            <Text
              size={{
                "@onlyMobile": "s",
                "@fromTablet": "m",
              }}
            >
              adres dostawy karty SIM
            </Text>
            <BlockText
              className="block capitalize"
              size={{
                "@onlyMobile": "s",
                "@fromTablet": "l",
              }}
              weight="bold"
            >
              {formatAddress(deliveryAddress, true)}
            </BlockText>
          </div>
        </div>
      )}
      {note && deliveryMethodId !== "ESIM" && (
        <div className="items-center flex">
          <Icon className={icon} name="comment" tone="accent" />
          <div className="flex-1">
            <Text
              size={{
                "@onlyMobile": "s",
                "@fromTablet": "m",
              }}
            >
              wiadomość dla kuriera
            </Text>
            <BlockText
              breakLongValue="force"
              className="block"
              size={{
                "@onlyMobile": "s",
                "@fromTablet": "l",
              }}
              weight="bold"
            >
              {note}
            </BlockText>
          </div>
        </div>
      )}
    </div>
  );
}
